import React from 'react';
import { Link } from 'gatsby';
import { getPostPath } from '../../../model/post';
import { Section } from '../index';

const LongRead = ({
  issue,
  lazyLoad
}) => {
  const {
    tghpwipIssuesTaxonomyColor: issueColor,
    posts: { nodes: issuePosts },
  } = issue;

  const {
    slug,
    featuredImage,
  } = issuePosts[0];

  const postImage = featuredImage?.node;

  const linkProps = {
    to: getPostPath(slug),
  };

  return (
    <Section
      type="long-read"
      spotlightPosts={[issuePosts[0]]}
      issue={issue}
      color={issueColor ? issueColor : `black`}
      expandButtonLocation={false}
    >
      <Link position="beforeRestPosts" {...linkProps} className="long-read-issue-grid__image">
        {postImage && (
          <img
            src={postImage.publicUrl}
            srcSet={postImage.srcSet}
            alt={postImage.altText}
            sizes="100vw"
            loading={lazyLoad ? 'lazy' : 'eager'}
          />
        )}
      </Link>
      <Link
        position="beforeRestPosts"
        {...linkProps}
        className="long-read-issue-grid__intro intro-titles"
      >
        <div className="intro-titles__label">Long Read</div>
        <div className="intro-titles__name">Article</div>
      </Link>
      <div className="long-read-issue-grid__mobile-footer">
        <Link {...linkProps} className="long-read-issue-grid__mobile-watch-button">
          Read now
        </Link>
      </div>
    </Section>
  );
};

export default LongRead;
